import { render, staticRenderFns } from "./OrderCirculateConfig.vue?vue&type=template&id=be6638e0"
import script from "./OrderCirculateConfig.vue?vue&type=script&lang=js"
export * from "./OrderCirculateConfig.vue?vue&type=script&lang=js"
import style0 from "./OrderCirculateConfig.vue?vue&type=style&index=0&id=be6638e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports